class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Bind the new methods to the instance
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
  }

  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
    this.mainDetailsToggle.addEventListener('click', this.onMenuClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback && super.disconnectedCallback();
    this.mainDetailsToggle.removeEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onMouseLeave);
    this.mainDetailsToggle.removeEventListener('click', this.onMenuClick);
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.onToggle();
  }

  onMouseLeave() {
    this.mainDetailsToggle.removeAttribute('open');
    this.onToggle();
  }

  onMenuClick(event) {
    const target = event.target.closest('summary, header-menu');
    if (!target || !target.matches('summary')) return;

    // Prevent the default behavior to avoid toggling the <details> element
    event.preventDefault();

    // Retrieve the target URL from the data attribute
    const targetUrl = target.getAttribute('data-target-url');

    // Navigate to the URL if it's defined
    if (targetUrl) {
      window.location.href = targetUrl;
    }
  }

  onToggle() {
    super.onToggle && super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
